// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { FactoryWithChoiceContext } from '@digitalasset/utility-operator-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useUtilityRegistryApiClient } from '../../../../../contexts/UtilityRegistryApiContext';

export const useBurnContext: () => UseMutationResult<
  FactoryWithChoiceContext,
  string,
  {
    registrar: string;
    holder: string;
    instrumentId: string;
  }
> = () => {
  const registryApi = useUtilityRegistryApiClient();

  return useMutation({
    mutationKey: ['burnContext', registryApi],
    mutationFn: async ({ registrar, holder, instrumentId }) => {
      return registryApi.getBurnContext({
        holder,
        instrumentId: {
          admin: registrar,
          id: instrumentId,
        },
      });
    },
    retry: false,
  });
};
